'use client';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@pickleballinc/react-ui';
import CustomLink from '@pickleballinc/ui/components/ui/custom-link';
import { useEffect, useState } from 'react';

import { publicEnv } from '@/lib/env';
import { getLoginUrl } from '@/utils/helpers/getLoginUrl';

const AccessLimited = () => {
  const [url, setUrl] = useState('');

  useEffect(() => {
    setUrl(getLoginUrl(`https://${publicEnv.NEXT_PUBLIC_HOME_ROOT_URL}/players`));
  }, []);

  return (
    <div className='container mx-auto my-16 flex flex-col justify-center'>
      <div className='flex w-full items-center justify-between'>
        <div className='flex-1 text-center text-3xl font-bold leading-7 md:text-4xl'>
          Oops! It seems you&apos;re not logged in as this player.
        </div>
      </div>
      <div className='mt-4 text-center text-lg font-normal text-gray-600'>Access is limited.</div>
      <div className='flex justify-center gap-2 pt-6'>
        <CustomLink href='/'>
          <Button variant='secondary' size='sm' prefixIcon={<FontAwesomeIcon icon={faArrowLeft} />}>
            Back to home
          </Button>
        </CustomLink>
        <CustomLink href={url} rel='nofollow'>
          <Button variant='primary' size='sm'>
            Login
          </Button>
        </CustomLink>
      </div>
    </div>
  );
};

export default AccessLimited;
